const ASSIGNMENT_TYPE = {
  GROUP: 'GROUP',
  PERSON: 'PERSON',
};

export default ASSIGNMENT_TYPE;
